import { User } from "@/modules/user/class-definitions/user";

/**
 * - Converts the data returned from Hasura to an array of User instances.
 * @param {array} subscription - The array holding the data of the Users's.
 * @returns {User[]} userList - The array of instantiated Users's.
 */
export const filterUserListSubscription = subscription => {
  return subscription.data.user.map(user => {
    return new User({
      id: user.id,
      name: user.name,
      email: user.email,
      authId: user.authId,
      team: user.user_team
    });
  });
};
